module.exports = __webpack_public_path__ + "static/media/sliders-h.cf08132b.svg";